import React from "react"

import { RenderHtml } from "@fuse/sharedComponents/renderHtml"

const RenderEventDescription = ({
  eventDescription,
}: {
  eventDescription: string
}) => {
  const linkRegex = /(https?:\/\/[^\s]+)/g
  const lines = eventDescription
    ?.split(/(\n)/) // Split by newlines to preserve them
    .map((line, index) => {
      if (line === "\n") {
        // If it's a newline, render a <br /> tag
        return <br key={index} />
      }

      // Split the line based on the URL regex
      const parts = line.split(linkRegex).map((part, index) => {
        if (linkRegex.test(part)) {
          // If the part is a URL, render it as an anchor tag
          return (
            <a
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              {part}
            </a>
          )
        }
        // Otherwise, render as regular text
        return <span key={index}>{part}</span>
      })

      return <React.Fragment key={index}>{parts}</React.Fragment>
    })

  return <div>{lines}</div>
}

export default RenderEventDescription

export const RenderEventDescriptionViaHtml = ({
  eventDescriptionViaHtml,
}: {
  eventDescriptionViaHtml: string
}) => {
  if (!eventDescriptionViaHtml) return null

  return (
    <div className="mb-6">
      <RenderHtml
        htmlContent={eventDescriptionViaHtml}
        className="text-md text-start text-white/90"
      />
    </div>
  )
}
